import React from 'react';
import SEO from '../../components/SEO';
const PravicyPolicy = () => {
    return (
        <div className="easyLeaseContainer">
            <SEO title="Privacy Policy" description="One-Stop Transport & Finicial Solution" path="privacy-policy" />
            <h2 className="sectionTitle text-center">Pravicy Policy</h2>
            <p className="paragraph">
                Easy Lease respects your privacy and is committed to protecting it through our compliance with this
                policy. This policy describes the types of information we may collect from you or that you may provide
                when you visit the website www.easylease.com (our “Website”) and our practices for collecting, using,
                maintaining, protecting, and disclosing that information.
            </p>
            <p className="paragraph">This policy applies to information we collect:</p>
            <ul>
                <li>on this Website;</li>
                <li>in email, text, and other electronic messages between you and this Website;</li>
                <li>
                    through mobile and desktop applications you may download from this Website, which provide dedicated
                    non-browser-based interaction between you and this Website; and
                </li>
                <li>
                    when you interact with our advertising and applications on third-party websites and services, if
                    those applications or advertising include links to this policy.
                </li>
            </ul>
            <p className="paragraph">This policy does not apply to information collected by:</p>
            <ul>
                <li>
                    us offline or through any other means, including on any other website operated by Company or any
                    third party (including our affiliates and subsidiaries); or
                </li>
                <li>
                    any third party (including our affiliates and subsidiaries), including through any application or
                    content (including advertising) that may link to or be accessible from or on the Website
                </li>
            </ul>
            <br />
            <p className="paragraph">
                Please read this policy carefully to understand our policies and practices regarding your information
                and how we will treat it. If you do not agree with our policies and practices, your choice is not to use
                our Website. By accessing or using this Website, you agree to this privacy policy. This policy may
                change from time to time, and your continued use of this Website after we make changes is deemed to be
                acceptance of those changes, so please check the policy periodically for updates.
            </p>
            <hr /> <br />
            <h3 className="blockTitle">Information We Collect About You and How We Collect It</h3>
            <p className="paragraph">
                We collect several types of information from and about users of our Website, including information by
                which you may be personally identified, such as your name, postal address, e- mail address, telephone
                number, driver license number, and credit card information. We also collect information about how you
                accessed this Website (e.g. from the yoma car share app or from an advertisement on a third-party
                website). We collect this information directly from you when you provide it to us. This includes
                information provided at the time of signing up to get more information, registering to our service. We
                may also ask you for information when you enter a contest, promotion, when you respond to surveys on
                this Website, and when you report a problem with our Website.
            </p>
            <p className="paragraph">
                Alternatively, we may collect information automatically as you navigate through the site. Information
                collected automatically may include usage details, IP addresses, and information collected through
                cookies, web beacons, and other tracking technologies. The information we collect automatically helps us
                to improve our Website and to deliver a better and more personalized service, including by enabling us
                to:
            </p>
            <ul>
                <li>estimate our audience size and usage patterns;</li>
                <li>
                    store information about your preferences, allowing us to customize our Website according to your
                    individual interests;
                </li>
                <li>speed up your searches; and</li>
                <li>recognize you when you return to our Website.</li>
                <br />
            </ul>
            <hr /> <br />
            <h3 className="blockTitle">How We Use Your Information</h3>
            <ul>
                <li>to present our Website and its contents to you;</li>
                <li>to provide you with information, products, or services that you request from us;</li>
                <li>to fulfill any other purpose for which you provide it;</li>
                <li>to provide you with notices about your account and membership;</li>
                <li>
                    to carry out our obligations and enforce our rights arising from any contracts entered into between
                    you and us, including for billing and collection;
                </li>
                <li>to notify you about changes to our Website and service;</li>
                <li>in any other way we may describe when you provide the information; and</li>
                <li>for any other purpose with your consent.</li>
                <br />
            </ul>
            <hr /> <br />
            <h3 className="blockTitle">Data Security</h3>
            <p className="paragraph">
                We have implemented measures designed to secure your personal information from accidental loss and from
                unauthorized access, use, alteration, and disclosure. All information you provide to us is stored on our
                secure servers and behind firewalls.
            </p>
            <p className="paragraph">
                The safety and security of your information also depends on you. Where we have given you (or where you
                have chosen) a password for access to certain parts of our Website, you are responsible for keeping this
                password confidential. We ask you not to share your password with anyone.
            </p>
            <p className="paragraph">
                Unfortunately, the transmission of information via the internet is not completely secure. Although we do
                our best to protect your personal information, we cannot guarantee the security of your personal
                information transmitted to our Website. Any transmission of personal information is at your own risk. We
                are not responsible for circumvention of any privacy settings or security measures contained on the
                Website.
            </p>
            <br />
            <hr /> <br />
            <h3 className="blockTitle">Contact Information</h3>
            <p className="paragraph">
                To ask questions or comment about this privacy policy, contact us at:{' '}
                <a href="mailto: aung@yomafleet.com">aung@yomafleet.com</a> or via our hotline number: 09 966235338 (09
                YOMAFLEET).
            </p>
        </div>
    );
};

export default PravicyPolicy;
